import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/RecentNewsletterWidget.css';
import api from './api';
import CustomModal from './CustomModal';
import Statistics from './Statistics';

const RecentNewsletterWidget = ({ onViewStatistics }) => {
  const [latestNewsletter, setLatestNewsletter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showStatisticsModal, setShowStatisticsModal] = useState(false);

  useEffect(() => {
    fetchLatestNewsletter();
  }, []);

  const fetchLatestNewsletter = async (retry = true) => {
    try {
      let token = localStorage.getItem('token');

      if (!token) {
        console.error("No token found");
        setError("Authentication error");
        setLoading(false);
        return;
      }

      const response = await api.get(`${process.env.REACT_APP_API_URL}/get-statistics`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Filter out emails without a date, then sort by newest first
      const sortedEmails = response.data
        .filter(stat => stat.dateSent) 
        .sort((a, b) => new Date(b.dateSent) - new Date(a.dateSent));

      if (sortedEmails.length > 0) {
        setLatestNewsletter(sortedEmails[0]);
      } else {
        setError("No newsletters found");
      }
      
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 403 && retry) {
        console.warn("Token expired, refreshing...");
        await refreshToken();
        fetchLatestNewsletter(false); // Retry once after refreshing
      } else {
        console.error("Error fetching latest newsletter:", error);
        setError("Failed to fetch newsletter data");
        setLoading(false);
      }
    }
  };

  const refreshToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');

      if (!refreshToken) {
        console.error("No refresh token found");
        setError("Authentication error");
        setLoading(false);
        return;
      }

      const response = await api.post(`${process.env.REACT_APP_API_URL}/refresh-token`, { refreshToken });

      if (response.data.accessToken) {
        localStorage.setItem('token', response.data.accessToken);
        console.log("Token refreshed successfully!");
      } else {
        console.error("Failed to refresh token");
        setError("Authentication error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
      setError("Authentication error");
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('nl-NL', options);
  };

  const formatPercentage = (percentage) => {
    return Math.round(percentage);
  };

  const handleViewStatistics = () => {
    if (onViewStatistics) {
      // Use the parent's handler if provided
      onViewStatistics();
    } else {
      // Otherwise show our own modal
      setShowStatisticsModal(true);
    }
  };

  return (
    <>
      <div className="card">
        <h3>Recente nieuwsbrief</h3>
        
        {loading ? (
          <p>Laden...</p>
        ) : error ? (
          <>
            <p>Geen recente nieuwsbrief gevonden</p>
            <button
              onClick={handleViewStatistics}
              className="custom-button"
              style={{ marginTop: '10px', width: '100%' }}
            >
              Bekijk statistieken
            </button>
          </>
        ) : (
          <>
            {latestNewsletter ? (
              <p>
                Laatste e-mail is aan <strong>{latestNewsletter.sent} </strong>e-mails verzonden op <strong>{formatDate(latestNewsletter.dateSent)} </strong>
                met onderwerp <i>"{latestNewsletter.subject}"</i> en <strong>{formatPercentage(latestNewsletter.percentUniqueOpens)}%</strong> heeft 'm gelezen.
              </p>
            ) : (
              <p>Geen recente nieuwsbrief gevonden</p>
            )}
            
            <button 
              onClick={handleViewStatistics} 
              className="custom-button" 
              style={{ marginTop: '10px', width: '100%' }}
            >
              Bekijk statistieken
            </button>
          </>
        )}
      </div>

      {/* Statistics Modal - Only show if not using parent handler */}
      {!onViewStatistics && (
        <CustomModal 
          isOpen={showStatisticsModal} 
          onClose={() => setShowStatisticsModal(false)}
          title="Email Statistics"
          isStatistics={true}
        >
          <Statistics />
        </CustomModal>
      )}
    </>
  );
};

export default RecentNewsletterWidget;